import { pagination_params } from '../../shared/utils/pagination_params';

export const getParamsUrl = (params) => {
  if (!params) return '';
  let path = '';
  path = pagination_params(params);

  params.CodigoElementoTipo &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoElementoTipo=${params.CodigoElementoTipo}`);
  params.Activo && (path = `${path !== '' ? `${path}&` : ''}Activo=${params.Activo}`);
  if (params.Descripcion) {
    path = `${path ? `${path}&` : ''}Descripcion=${encodeURIComponent(params.Descripcion)}`;
  }

  return path;
};
